var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: "设备信息", visible: true, "before-close": _vm.closeBox }
    },
    [
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            { attrs: { label: "设备编号" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "设备编号",
                  disabled: _vm.form.machine_id != ""
                },
                model: {
                  value: _vm.form.machine_no,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "machine_no", $$v)
                  },
                  expression: "form.machine_no"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "格口数量" } },
            [
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("（设置格口数量需小于实际格口数量，留出异常格口）")
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { placeholder: "格口数量" },
                model: {
                  value: _vm.form.grid_num,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "grid_num", $$v)
                  },
                  expression: "form.grid_num"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "IP" } },
            [
              _c("el-input", {
                attrs: { placeholder: "IP" },
                model: {
                  value: _vm.form.ip,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "ip", $$v)
                  },
                  expression: "form.ip"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "端口" } },
            [
              _c("el-input", {
                attrs: { placeholder: "port" },
                model: {
                  value: _vm.form.port,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "port", $$v)
                  },
                  expression: "form.port"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "一键打包:" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "一键打包" },
                  model: {
                    value: _vm.form.is_check_one_out,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "is_check_one_out", $$v)
                    },
                    expression: "form.is_check_one_out"
                  }
                },
                _vm._l(_vm.ops_is_check_one_out, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.name, value: item.key }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.closeBox } }, [_vm._v("取 消")]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.addMachine } },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20d49147", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d49147","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/machine/components/edit.vue
// module id = null
// module chunks = 